import { SerializedBuffer } from '@agilelab/plugin-wb-platform-common';
import { z } from 'zod';

export const TechnologySchema = z.object({
  urn: z.string().min(1, 'URN is required'),
  name: z.string().min(1, 'Name is required'),
  description: z.string().optional().nullable(),
  icon: z.instanceof(Buffer).optional().nullable(),
  created_by: z.string().optional(),
  created_at: z.date().optional(),
  updated_by: z.string().optional(),
  updated_at: z.date().optional(),
});

export type Technology = z.infer<typeof TechnologySchema>;

export type SerializedTechnology = Omit<Technology, 'icon'> & {
  icon?: SerializedBuffer | null;
};

export type TechnologyCreate = Omit<
  Technology,
  'created_at' | 'updated_at' | 'created_by' | 'updated_by'
>;
